/**
 * Pipeline Snapshots — public API.
 *
 * Snapshots are compact, serializable projections of pipeline runs. They
 * enable diffing two runs to spot regressions or quantify the impact of a
 * fix. See snapshots/types.ts for the schema and snapshots/createSnapshot.ts
 * for the conversion from PipelineBatchResult.
 */
export { createSnapshot } from './createSnapshot'
export { diffSnapshots } from './diffSnapshots'
export {
  listSnapshots,
  loadSnapshot,
  saveSnapshot,
  deleteSnapshot,
  clearAllSnapshots,
  getSnapshotCap,
} from './snapshotStorage'
export type { SnapshotIndexEntry } from './snapshotStorage'
export type {
  PipelineSnapshot,
  SnapshotAggregate,
  SnapshotQuestionRow,
  SnapshotRunConfig,
  SnapshotDiff,
} from './types'
